/**
 * Danh mục **mọi đường ra ngoài** của AutoIME, và mỗi đường cần những gì.
 *
 * **Danh mục là mã, giá trị là dữ liệu** — cùng luật với `ai-catalog.ts` và `DANH_MUC_CAI_DAT`.
 * Thêm một đường ra là thêm một mục ở đây; màn Kết nối, kho bí mật và phép kiểm đều đọc từ đây
 * nên không chỗ nào phải sửa thêm.
 *
 * Viết 10/09/2026, khi Lynust yêu cầu *"mở toàn bộ kết nối"*. Trước đó chỉ ba khoá AI dán được
 * qua dashboard; tài khoản Website IME và token Facebook **chỉ có đường `.env`**, tức là muốn
 * đổi thì phải SSH vào máy chủ.
 */
export const DANH_MUC_KET_NOI = [
    {
        khoa: "ime",
        ten: "Website IME — automation API",
        moTa: "Đích đăng bài. API bên đó đòi JWT chứ không nhận API key, nên AutoIME đăng nhập bằng tài " +
            "khoản automation rồi lấy token. Token hết hạn 1 ngày, lấy tại lúc dùng.",
        thieuThiSao: "Không đăng được bài nào lên website. Job `dang-web` ném.",
        kiemDuoc: true,
        huongDan: "Tài khoản phải có role SiteEditor và được gán ĐỦ 5 site. Thiếu một site thì đăng được " +
            "site này và 403 ở site kia — phép kiểm dưới đây đọc đúng hai thứ đó ra.",
        truong: [
            {
                khoa: "ketnoi.ime.apiUrl",
                nhan: "URL API",
                biMat: false,
                bienEnv: "IME_API_URL",
                batBuoc: true,
                goiY: "https://api.imemedical.com.vn — không có dấu / ở cuối",
            },
            {
                khoa: "ketnoi.ime.email",
                nhan: "Email tài khoản automation",
                biMat: false,
                bienEnv: "IME_AUTOMATION_EMAIL",
                batBuoc: true,
                goiY: "Tài khoản riêng cho máy, không dùng chung với tài khoản người",
            },
            {
                khoa: "ketnoi.ime.matKhauEnc",
                nhan: "Mật khẩu",
                biMat: true,
                bienEnv: "IME_AUTOMATION_PASSWORD",
                batBuoc: true,
                goiY: "Lưu mã hoá. Dán xong không xem lại được — chỉ dán đè cái mới.",
            },
        ],
    },
    {
        khoa: "facebook",
        ten: "Facebook — fanpage",
        moTa: "Đăng bài lên fanpage; link về website nằm ở COMMENT đầu tiên. Cần scope " +
            "`pages_manage_posts` và `pages_manage_engagement` — thiếu cái thứ hai thì bài lên được " +
            "nhưng comment hỏng câm, mà comment đó là đường DUY NHẤT từ Facebook về website (AP-17).",
        thieuThiSao: "Bài web vẫn đăng bình thường; chỉ Facebook không chạy.",
        kiemDuoc: true,
        huongDan: "Dán App ID + App Secret (Meta for Developers → Settings → Basic) và một User token lấy ở " +
            "Graph API Explorer với hai scope trên. AutoIME tự đổi sang Page token DÀI HẠN và lưu ngày " +
            "hết hạn — token ngắn anh dán vào KHÔNG được lưu lại.",
        truong: [
            {
                khoa: "ketnoi.facebook.appId",
                nhan: "App ID",
                biMat: false,
                bienEnv: "FB_APP_ID",
                batBuoc: true,
                goiY: "Dãy số, Meta for Developers → Settings → Basic",
            },
            {
                khoa: "ketnoi.facebook.appSecretEnc",
                nhan: "App Secret",
                biMat: true,
                bienEnv: "FB_APP_SECRET",
                batBuoc: true,
                goiY: "Cùng trang với App ID, bấm Show",
            },
        ],
        truongTuSinh: [
            {
                khoa: "ketnoi.facebook.pageId",
                nhan: "Page ID",
                biMat: false,
                // Giữ biến cũ làm đường dự phòng: bản trước 10/09/2026 chỉ có đường `.env`.
                bienEnv: "FB_PAGE_ID",
                batBuoc: true,
                goiY: "AutoIME điền sau khi anh chọn trang",
            },
            {
                khoa: "ketnoi.facebook.pageTokenEnc",
                nhan: "Page token dài hạn",
                biMat: true,
                bienEnv: "FB_PAGE_TOKEN",
                batBuoc: true,
                goiY: "AutoIME tự đổi ra từ token ngắn",
            },
        ],
    },
    {
        khoa: "anthropic",
        ten: "Anthropic — model viết bài",
        moTa: "Model thật. Chưa có thì cả dây chuyền vẫn chạy bằng model đóng thế — $0, không chạm mạng, " +
            "và bài ra là bài mẫu chứ không phải văn.",
        thieuThiSao: "Hệ VẪN CHẠY đầy đủ bằng model đóng thế. Đây là lý do dựng xong được mọi thứ trước khi nạp " +
            "một đồng nào.",
        kiemDuoc: true,
        huongDan: "console.anthropic.com → API keys. Khoá bắt đầu bằng `sk-ant-`.",
        truong: [
            {
                khoa: "khoa.anthropicEnc",
                nhan: "API key",
                biMat: true,
                bienEnv: "ANTHROPIC_API_KEY",
                batBuoc: true,
                goiY: "sk-ant-…",
            },
        ],
    },
    {
        khoa: "telegram",
        ten: "Telegram — báo động",
        moTa: "Đường báo động DUY NHẤT. Job chết, bài chờ duyệt, token sắp hết hạn — tất cả đi qua đây. " +
            "Bộ đếm trên dashboard KHÔNG phải thông báo (AP-31).",
        thieuThiSao: "Mọi cảnh báo hỏng CÂM. Chó canh vẫn chạy mỗi 5 phút nhưng không gửi được gì, và triệu " +
            "chứng giống hệt 'hệ thống đang yên ổn'.",
        kiemDuoc: true,
        huongDan: "Bot token: @BotFather → /mybots → chọn bot → API Token. " +
            "Chat id nhóm: thêm bot vào nhóm, gõ một tin bất kỳ trong đó, rồi bấm Lưu — nếu ô chat id " +
            "còn trống, AutoIME gọi getUpdates và LIỆT KÊ các nhóm nó thấy để bạn dán vào. Nó không " +
            "tự điền: một chat id đoán sai là cảnh báo bắn vào nhầm nhóm. " +
            "Phép kiểm cũng đọc luôn privacy mode — bật thì bot KHÔNG thấy ảnh mọi người gửi.",
        truong: [
            {
                khoa: "ketnoi.telegram.botTokenEnc",
                nhan: "Bot token",
                biMat: true,
                bienEnv: "TELEGRAM_TOKEN_CONTENT",
                batBuoc: true,
                goiY: "Dạng 123456789:AA… — lấy từ @BotFather",
            },
            {
                khoa: "telegram.chatIdNhom",
                nhan: "Chat id nhóm",
                biMat: false,
                bienEnv: null,
                batBuoc: true,
                goiY: "Số âm cho nhóm. ⚠️ Nhóm lên siêu nhóm là id ĐỔI — phải cập nhật lại.",
            },
            {
                khoa: "telegram.userIdTruongNhom",
                nhan: "User id của Lynust",
                biMat: false,
                bienEnv: null,
                batBuoc: false,
                goiY: "Để nhắn riêng dạy bot. Bỏ trống cũng chạy.",
            },
        ],
    },
    {
        khoa: "model-phu",
        ten: "Model phụ — OpenAI và Gemini",
        moTa: "Chỉ cần khi chạy eval so sánh model. Dây chuyền hằng ngày không gọi tới. Thiếu thì màn " +
            "So sánh model chỉ chấm được các model Anthropic.",
        thieuThiSao: "Không ảnh hưởng việc sản xuất bài. Chỉ eval bị thu hẹp.",
        kiemDuoc: true,
        huongDan: "platform.openai.com → API keys · aistudio.google.com → Get API key.",
        truong: [
            {
                khoa: "khoa.openaiEnc",
                nhan: "OpenAI API key",
                biMat: true,
                bienEnv: "OPENAI_API_KEY",
                batBuoc: false,
                goiY: "sk-…",
            },
            {
                khoa: "khoa.googleEnc",
                nhan: "Gemini API key",
                biMat: true,
                bienEnv: "GEMINI_API_KEY",
                batBuoc: false,
                goiY: "AIza…",
            },
        ],
    },
    {
        khoa: "google-sa",
        ten: "Google service account — GA4 và Sheets",
        moTa: "Hai file JSON RIÊNG: một chỉ-đọc cho GA4 + Search Console (đúc kết chân dung khách), một " +
            "có quyền-ghi cho Google Sheets (báo cáo research). Dùng chung một file là cho quyền ghi " +
            "vào chỗ chỉ cần đọc.",
        thieuThiSao: "Chân dung khách không tự đúc kết được, và báo cáo research không ghi ra Sheet. Việc sản " +
            "xuất bài vẫn chạy.",
        kiemDuoc: false,
        chuaDung: "Lưu được, nhưng CHƯA có dòng code nào đọc tới — Luồng 3 (research + Google Sheet) và phần " +
            "đúc kết GA4 đều chưa dựng. Dán sẵn ở đây thì lúc dựng xong là chạy ngay.",
        huongDan: "Google Cloud Console → IAM → Service Accounts → Keys → Add key → JSON. Chia sẻ property " +
            "GA4 (quyền Viewer) và file Sheet (quyền Editor) cho địa chỉ email của service account.",
        truong: [
            {
                khoa: "ketnoi.google.saDocEnc",
                nhan: "Service account CHỈ ĐỌC (GA4 + Search Console)",
                biMat: true,
                bienEnv: "GOOGLE_SA_DOC_JSON",
                batBuoc: false,
                goiY: "Dán nguyên nội dung file JSON",
                nhieuDong: true,
            },
            {
                khoa: "ketnoi.google.saGhiEnc",
                nhan: "Service account CÓ QUYỀN GHI (Sheets)",
                biMat: true,
                bienEnv: "GOOGLE_SA_GHI_JSON",
                batBuoc: false,
                goiY: "File JSON KHÁC với cái trên",
                nhieuDong: true,
            },
        ],
    },
];
export function timHangKetNoi(khoa) {
    return DANH_MUC_KET_NOI.find((h) => h.khoa === khoa);
}
/** Mọi trường của mọi đường, phẳng ra — để kho bí mật tra một khoá là biết nó bí mật hay không. */
export function timTruongKetNoi(khoa) {
    for (const h of DANH_MUC_KET_NOI) {
        const t = [...h.truong, ...(h.truongTuSinh ?? [])].find((x) => x.khoa === khoa);
        if (t)
            return t;
    }
    return undefined;
}
/**
 * Khoá bí mật **phải** kết thúc bằng `Enc`, khoá thường **không được**.
 *
 * Quy ước của `data-model.md` §1, và nó có mục đích vận hành: nhìn một lần
 * `db.caidat.find()` là biết cột nào chứa gì mà không phải tra tài liệu. Hàm này để test canh —
 * đặt sai tên là giá trị thật nằm trần trong database mà không ai thấy.
 */
export function tenKhoaDungQuyUoc(t) {
    return t.biMat === t.khoa.endsWith("Enc");
}
/**
 * Đã nhập đủ những thứ **người phải gõ** chưa. **Không tính trường máy tự sinh.**
 *
 * Hàm này tồn tại vì một **bế tắc** đo được ngày 10/09/2026 trên production:
 *
 * `KhoiFacebook` mở khoá ô "token ngắn" bằng `truong.filter(t => t.batBuoc).every(t => t.co)`.
 * Nhưng danh sách trường mà API trả về đã **gộp `truongTuSinh` vào `truong`**, mà `pageId` và
 * `pageTokenEnc` đều `batBuoc: true`. Hai trường đó chỉ có được **sau** phép đổi token.
 *
 * ⇒ Không có Page token thì ô dán token ngắn bị khoá; ô bị khoá thì không đổi được token; không
 * đổi được token thì không bao giờ có Page token. Facebook **không thể nối được qua giao diện**,
 * trong khi `pnpm build`, `tsc` và toàn bộ test đều xanh — cùng họ với `P-11`.
 *
 * Đặt ở đây, thuần, có test, để cả giao diện lẫn máy chủ hỏi **một** câu hỏi bằng **một** đường.
 */
export function duNhapTay(truong) {
    return truong.filter((t) => t.batBuoc && !t.tuSinh).every((t) => t.co);
}
/**
 * Trường **máy tự sinh và bắt buộc** của một đường.
 *
 * Đây là tập **duy nhất** được phép chặn một lượt kiểm thật. Người chưa gõ xong thì phép kiểm
 * vẫn nói được điều có ích — với Telegram nó còn gọi `getUpdates` và **liệt kê các nhóm** để dán
 * chat id vào. Máy chưa sinh ra thì phép kiểm không nói thêm được gì.
 *
 * Có mặt vì một lá chắn viết vội 10/09/2026 tính cả trường người gõ và **giết mất** đúng nhánh
 * liệt kê nhóm đó. `pre-ship-reviewer` bắt được trước khi deploy.
 */
export function truongTuSinhBatBuoc(h) {
    return (h.truongTuSinh ?? []).filter((t) => t.batBuoc);
}
//# sourceMappingURL=ket-noi.js.map